<template>
  <div>
    <ViewHeader>
      <CButton
        color="secondary"
        class="ra-button"
        @click="() => $downloadFile({
          url: ENTITY_FORMS_ENDPOINTS.export_forms,
          query: $refs.entity_form_table.tableQuery
        })"
      >
        Export
      </CButton>
      <CButton
        color="primary"
        class="ra-button"
        to="/entity-id-form/create"
      >
        Create
      </CButton>
    </ViewHeader>

    <tableComponent
      ref="entity_form_table"
      :url="ENTITY_FORMS_ENDPOINTS.main"
      :columns="columns"
      :filter-exclude-columns="['actions']"
      :sort-exclude-columns="['actions']"
      :key="refreshTable"
    >
      <template #actions="{ row }">
        <div class="d-flex gap-2">
          <CLink :to="{path:`/entity-id-form/${row.name}`, query: {preview: true}}">
            <CButton
              class="ra-icon-button"
              v-c-tooltip="'Preview form'"
            >
              <Icon name="eye"/>
            </CButton>
          </CLink>
          <CLink :to="`/entity-id-form/${row.name}/`">
            <CButton
              class="ra-icon-button"
              v-c-tooltip="'Edit form'"
            >
              <Icon name="pencil"/>
            </CButton>
          </CLink>
          <CButton
            class="ra-icon-button"
            v-c-tooltip="'Delete form'"
            @click="() => deleteForm(row)"
          >
            <Icon name="trash"/>
          </CButton>
        </div>
      </template>
    </tableComponent>
  </div>
</template>

<script>
import {ENTITY_FORMS_ENDPOINTS, EntityFormsService} from "@/services/entity_forms";

export default {
  name: "EntityForms",
  data() {
    return {
      ENTITY_FORMS_ENDPOINTS,
      columns: ['entity_code', 'name', 'financial_department', 'actions'],
      editId: null,
      refreshTable: 0,
    }
  },
  methods: {
    async deleteForm(form) {
      await EntityFormsService.deleteForm(form.name);
      this.refreshTable++;
    }
  }
}
</script>

<style scoped>
.delete-btn {
  margin-left: 4px;
}
</style>
